// Real-user speed (py-per 2026-11-02): what people actually wait for, measured in their own browser — every API
// call (including the slow home→HQ link) and each full page load / largest paint. Sent in small batches to
// /api/client-metrics (backend/features/rum.py); the SRM sees median and p75 per page and endpoint in Admin settings.
// Only paths (ids replaced) and milliseconds are sent.
const queue = [];
let timer = null;

const norm = (path) =>
    String(path || "")
        .split("?")[0]
        .replace(/^https?:\/\/[^/]+/, "")
        .replace(/^\/api(?=\/)/, "")
        .replace(/\/[0-9a-f]{8,}(-[0-9a-f]{4,})*|\/\d{3,}|\/[A-Za-z]+-[0-9A-Za-z-]{5,}/g, "/:id")
        .slice(0, 90);

export const flush = () => {
    timer = null;
    const token = localStorage.getItem("token");
    if (!queue.length || !token) {
        queue.length = 0;
        return;
    }
    const body = JSON.stringify({ events: queue.splice(0, 300) });
    fetch("/api/client-metrics", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body,
        keepalive: true,
    }).catch(() => {});
};

const push = (k, n, ms) => {
    if (!(ms >= 0) || queue.length >= 300) return;
    queue.push({ k, n, ms: Math.round(ms) });
    if (!timer) timer = setTimeout(flush, 30000);
};

export const recordApi = (url, ms) => {
    const n = norm(url);
    if (n && !n.startsWith("/client-metrics")) push("api", n, ms);
};

let started = false;
export const startRum = () => {
    if (started || typeof window === "undefined" || !window.performance) return;
    started = true;
    let lcp = 0;
    try {
        new PerformanceObserver((list) => {
            const e = list.getEntries().pop();
            if (e) lcp = e.startTime;
        }).observe({ type: "largest-contentful-paint", buffered: true });
    } catch {
        /* older browsers: no LCP */
    }
    const page = norm(window.location.pathname) || "/";
    const report = () => {
        const nav = performance.getEntriesByType("navigation")[0];
        if (nav) {
            push("page", "ttfb", nav.responseStart);
            if (nav.loadEventEnd > 0) push("page", `load ${page}`, nav.loadEventEnd);
        }
        if (lcp) push("page", `lcp ${page}`, lcp);
    };
    if (document.readyState === "complete") setTimeout(report, 3000);
    else window.addEventListener("load", () => setTimeout(report, 3000), { once: true });
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") flush();
    });
};
